<template>
<div class="task">
  <div class="header">
    <el-button @click="pageChange(1)">刷新</el-button>
    <el-button size="mini" @click="exportThirdPartyExcel()">导出第三方填报表</el-button>
  </div>
  <div class="table-wrap">
    <el-table
      v-loading="loading"
      v-if="pageData" :data="pageData.data"
      border
      style="width: 100%" height="60vh">
      <el-table-column
        prop="id"
        label="ID" width="80"></el-table-column>
      <el-table-column
        prop="project_name"
        label="项目"
        min-width="200">
      </el-table-column>
      <el-table-column
        prop="company_name"
        label="合作单位"
        min-width="250">
      </el-table-column>
      <el-table-column
        prop="task_id"
        label="审批流程"
        min-width="100">
        <template slot-scope="scope">
          <el-link type="primary"  v-if="scope.row.task_id" @click="openFlow(scope.row)">查看流程</el-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="excel_task_file"
        label="移交财务报表"
        min-width="120">
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.excel_task_file" @click="openViewFile(scope.row.excel_task_file)">查看</el-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="gz_file"
        label="项目盖章文件"
        min-width="120">
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.gz_file" @click="openViewFile(scope.row.gz_file)">查看</el-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="dsf_gz_file"
        label="第三方盖章文件"
        min-width="120">
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.dsf_gz_file" @click="openViewFile(scope.row.dsf_gz_file)">查看</el-link>&nbsp;&nbsp;
          <el-link type="primary" @click="uploadFile(scope.row.task_id)">上传</el-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="120">
        <template slot-scope="scope">
          {{statusObj[scope.row.status]||"未知"}}
        </template>
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="创建时间"
        min-width="200"></el-table-column>
      <el-table-column
        prop="update_time"
        label="更新时间"
        min-width="200"></el-table-column>
    </el-table>
  </div>
  <div class="pagination-wrap">
    <el-pagination background layout="prev, pager, next" :total="pageData.total"
                   :page-size="pageData.per_page" :current-page="pageData.current_page"
                   @current-change="pageChange"></el-pagination>
  </div>
  <ViewFile ref="viewFile" />
  <ViewFlow ref="viewFlowRef" />
</div>
</template>

<script>
import ButlerHttp from "../../common/ButlerHttp";
import ViewFile from "../../../Common/ViewFile";
import ViewFlow from "../../../Common/ViewFlow";
import {CommonHelp} from "../../common/CommonHelp";

export default {
  name: "ThridCompanyProjectTask",
  components: {ViewFlow, ViewFile},
  inject:['where','reginWhere'],
  props:{
    urge_type:{
      type:Number,
      default:3
    }
  },
  data(){
    return{
      // 状态：1计划导入成功，2生成报表中，3报表生成成功，4盖章中，5已经盖章，6第三方盖章回执
      statusObj:{
        1:"计划导入成功",
        2:"生成报表中",
        3:"报表生成成功",
        4:"盖章中",
        5:"已经盖章",
        6:"第三方盖章回执"
      },
      pageData: {
        data: [],
        total: 0,
        per_page: 20,
        current_page: 1,
      },
      loading: false,
    }
  },
  mounted() {
    this.pageChange(1)
  },
  methods:{
    pageChange(i) {
      this.pageData.current_page = i
      this.getList()
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = {
        ...that.where,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name
      }
      ButlerHttp.post(`ThridCompanyProjectTask/getSealList?page=${that.pageData.current_page}`, where, res => {
          that.loading = false;
          if (res.code) {
            that.pageData = res.data;
          }
        }
      )
    },
    openViewFile(src){
      this.$refs.viewFile.show({
        width: '90vw',
        height:'80vh',
        title:"预览",
        src:src,
        download(){
          // TODO 下载文件逻辑
          window.open(src)
        }
      })
    },
    openFlow(item){
      const that = this;
      if(!item.task_id){
        that.$message.error('没有审批流程')
        return;
      }
      that.$refs.viewFlowRef.show({task_id:item.task_id})
    },
    uploadFile(task_id){
      const that = this;
      __OSS__.setBucket("gdza").uploadFile(data=>{
        let file=data.path
        ButlerHttp.post("ThridCompanyProjectTask/uploadSealFile", {
          task_id:task_id,
          file_url: file
        }, res => {
          if (res.code) {
            that.$message.success(res.msg||"上传成功");
            that.pageChange(1);
          } else {
            that.$message.error(res.msg);
          }
        });
      });
    },
    exportThirdPartyExcel(){
      const that=this;
      if(!that.reginWhere.project_name){
        that.$message.error("请选择项目")
        return false
      }
      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let where = {
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id,
        urge_type:that.urge_type,
      }
      let urlObj={
        2:"Litigation/exportExcel",
        3:"ThirdPartyLegal/exportExcel",
        4:"ThirdPartyLitigation/exportExcel"
      }
      if(!urlObj[that.urge_type]){
        that.$message.error("计划催缴类型异常无法导出");
        return false
      }
      ButlerHttp.post(urlObj[that.urge_type], {
        ...where
      }, res => {
        loading.close();
        if (res.code) {
          that.$refs.ViewFile.show({
            width: '90vw',
            height: '80vh',
            title: "文件预览",
            src: __HTTP__.defaults.baseURL + res.data,
            download() {
              window.open(__HTTP__.defaults.baseURL + res.data);
            }
          });
        } else {
          that.$message.error(res.msg);
        }
      });
    },
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where.thrid_company_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
  }
}
</script>

<style lang="scss" scoped>
.task{

}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/thirdparty/ThridCompanyProjectTask.vue